// ----------------------------------------------------------------------------------------------------
//            USED FOR LARGE SCALE CONFIG CHANGES BASED ON FULFILLLMENT TIMELINE
// ----------------------------------------------------------------------------------------------------

// Add in a Work Station 0 for only Bar Soaps
export let barSoapWorkStationZeroActivate = true

// Add in a Work Station 6-8 for only Bar Soaps
export let comboWorkStationsActive = false